import { useState, useEffect, useRef, useCallback } from "react";

const AI_PLACEHOLDER_PHRASES = [
  "najam stana trešnjevka do 800€",
  "bmw 3 automatik 2018. god",
  "električni auto limuzina do 20k",
  "prodaja kuće u splitu",
];

const TYPING_SPEED = 50;
const DELETING_SPEED = 25;
const PAUSE_AFTER_TYPING = 2000;
const PAUSE_AFTER_DELETING = 400;

export function useAnimatedPlaceholder(isActive: boolean) {
  const [displayText, setDisplayText] = useState("");
  const [cursorVisible, setCursorVisible] = useState(true);
  const phraseIndex = useRef(0);
  const charIndex = useRef(0);
  const isDeleting = useRef(false);
  const timeoutRef = useRef(null);

  const animate = useCallback(() => {
    if (!isActive) return;

    const currentPhrase = AI_PLACEHOLDER_PHRASES[phraseIndex.current];

    if (!isDeleting.current) {
      // Typing
      charIndex.current++;
      setDisplayText(currentPhrase.slice(0, charIndex.current));

      if (charIndex.current === currentPhrase.length) {
        // Done typing, pause then start deleting
        isDeleting.current = true;
        timeoutRef.current = setTimeout(animate, PAUSE_AFTER_TYPING);
        return;
      }
      timeoutRef.current = setTimeout(animate, TYPING_SPEED);
    } else {
      // Deleting
      charIndex.current--;
      setDisplayText(currentPhrase.slice(0, charIndex.current));

      if (charIndex.current === 0) {
        // Done deleting, move to next phrase
        isDeleting.current = false;
        phraseIndex.current = (phraseIndex.current + 1) % AI_PLACEHOLDER_PHRASES.length;
        timeoutRef.current = setTimeout(animate, PAUSE_AFTER_DELETING);
        return;
      }
      timeoutRef.current = setTimeout(animate, DELETING_SPEED);
    }
  }, [isActive]);

  useEffect(() => {
    if (isActive) {
      timeoutRef.current = setTimeout(animate, PAUSE_AFTER_DELETING);
    } else {
      clearTimeout(timeoutRef.current);
      setDisplayText("");
      charIndex.current = 0;
      isDeleting.current = false;
    }

    return () => {
      clearTimeout(timeoutRef.current);
    };
  }, [isActive, animate]);

  // Blinking cursor
  useEffect(() => {
    if (!isActive) return;
    const interval = setInterval(() => {
      setCursorVisible(prev => !prev);
    }, 530);
    return () => clearInterval(interval);
  }, [isActive]);

  return { displayText, cursorVisible };
}



// WEBPACK FOOTER //
// ./src/containers/HomePage/hooks/useAnimatedPlaceholder.ts